/** @format */

import React, { FC, useEffect } from 'react'
import { Button, Card, Dialog, Message } from '@king-design/react'
import { useHistory } from 'react-router'
import { useAsyncFn } from 'react-use'
import styled from 'styled-components'
import { MonitorCrumb, TablePage } from 'src/components'
import useNavRegion from 'src/hooks/useNavRegion'
import { getPromethuesInstance, createPrometheusInstance } from 'src/api/ApiPromethuesInstance'
import { API } from 'src/api/ApiPromethuesInstance'
import useFormTable from 'src/hooks/useFormTable'

const InstanceInfo: FC<any> = ({ className }) => {
  // 控制台region
  const region = useNavRegion()
  const history = useHistory()

  // 账户下是否有实例
  const [{ value: haveInstance, loading: have_loading }, have_fetch] = useAsyncFn(async () => {
    const result = await getPromethuesInstance()
    return !!result?.InstancesSet?.length
  }, [])

  // 初始化
  useEffect(() => {
    have_fetch()
  }, [])

  // 获取资源
  useEffect(() => {
    if (haveInstance && region) {
      run({ SearchRegion: region })
    }
  }, [haveInstance, region])

  // useFormTable
  const { run, result, pageState, loading, total } = useFormTable(
    API.getPromethuesInstance,
    {
      params: {},
      manual: true
    },
    data => {
      return {
        tableData: data?.InstancesSet || [],
        totalCount: data?.totalCount
      }
    }
  )

  // 开通/新增prometheus实例
  const [, create_fetch] = useAsyncFn(
    async type => {
      const result = await createPrometheusInstance(region)
      if (result?.InstancesSet) {
        if (type === 'open') {
          Message.info('开通成功')
          have_fetch()
        } else {
          Message.info('新增成功')
          run({ SearchRegion: region })
        }
      }
      return result
    },
    [region]
  )

  const scheme = {
    ClusterName: {
      title: '实例名称'
    },
    ControllerID: {
      title: '实例ID'
    },
    StorageDuration: {
      title: '数据存储时长',
      width: 150,
      template({ StorageDuration }) {
        return StorageDuration ? `${StorageDuration}天` : '-'
      }
    },
    CreatedAt: {
      title: '创建时间',
      width: 200
    },
    action: {
      title: '操作',
      width: 100,
      template({ ClusterID }) {
        return (
          <a
            className="primary-color"
            onClick={() => {
              history.push(`/monitor/prometheusmonitor/instanceinfo/view/${ClusterID}`)
            }}
          >
            查看
          </a>
        )
      }
    }
  }

  // 开通实例二次确认
  const openActivate = async () => {
    Dialog.confirm({
      title: '确认开通？',
      content: '开通后将为您在当前region下创建Prometheus实例。是否开通？'
    }).then(
      async () => {
        await create_fetch('open')
      },
      () => {
        // 取消
      }
    )
  }
  // 新增实例二次确认
  const addInstance = async () => {
    Dialog.confirm({
      title: '确认新增？',
      content: '将为您在当前region下新增Prometheus实例。是否新增？'
    }).then(
      async () => {
        await create_fetch('add')
      },
      () => {
        // 取消
      }
    )
  }
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: 'Prometheus监控' }, { title: '实例信息' }]} />
      <Card>
        {!have_loading ? (
          haveInstance ? (
            <div className="instance_list">
              {!result?.length && result !== undefined ? (
                <Button className="add_button" onClick={addInstance} type="primary">
                  新增Prometheus实例
                </Button>
              ) : null}
              <TablePage
                style={{ marginTop: 0 }}
                tableProps={{
                  data: result || [],
                  scheme: scheme,
                  checkType: 'none',
                  rowKey: value => value.clusterId,
                  rowCheckable: false
                }}
                pageProps={{ total, ...pageState }}
                loading={loading}
                run={run}
              />
            </div>
          ) : (
            <div className="activate_box">
              <h3>开通金山云Prometheus监控服务</h3>
              <p>
                金山云Prometheus监控提供多维度数据采集、强大査询语言和实时告警能力，助力您精准掌控云上服务健康状态与性能指标。
              </p>
              <Button type="primary" onClick={openActivate}>
                开通实例
              </Button>
            </div>
          )
        ) : null}
      </Card>
    </div>
  )
}

export default styled(InstanceInfo)`
  .instance_list {
    .add_button {
      margin-bottom: 16px;
    }
  }
  .activate_box {
    h3 {
      font-size: 18px;
    }
    p {
      margin: 16px 0;
      font-size: 14px;
    }
  }
`
